'use client';

import { MotionConfig } from 'motion/react';
import { ThemeProvider as NextThemesProvider, ThemeProviderProps } from 'next-themes';

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return (
    <NextThemesProvider {...props}>
      {/* `reducedMotion="user"` in one place rather than a `useReducedMotion()` in every animated
          component. The `prefers-reduced-motion` block in globals.css only overrides CSS
          animation and transition durations — it cannot reach Motion, which drives its animations
          through WAAPI and rAF. Without this the site's most prominent motion (the mobile menu,
          the Industries dropdown, the `layoutId` indicators, the travelling nav highlight) is
          exactly what a reduced-motion visitor still gets. */}
      <MotionConfig reducedMotion="user">{children}</MotionConfig>
    </NextThemesProvider>
  );
}
